// FLOW is A pain here, redo or something ...!
// @flow
/**
 * Module
 *
 * Given a Module ID,
 * Holds all the lessons and tests,
 * users click between each sequentially,
 * the module info and progress are independent
 * of the lessons / tests
 */

import React, {Component} from 'react';
import type {Node} from 'react';
import Page from '../../containers/page/page.js';
import {
  ModuleInformation,
} from './ModulePresentational.js';
import {
  ModuleProgress,
} from './ModuleProgress.js';
import ModuleComponents from '../ModuleComponents/ModuleComponents.js';
import {Redirect} from 'react-router-dom';
import type {
  ResourcesType,
  ModuleFieldsType,
  ModuleComponentType,
  TranslateType,
} from '../../types.js';
import styles from './Module.module.css';
import translate from '../../config/text';
import {getFromLocalStorage} from "../../utility/utility";
import {LOGIN} from "../../redux/actions/action-types";

// a flag for endpoint (manual so far)
// master branch must always have value false !!
const staging = false;


type PropsType = {
  resources: ResourcesType,
  loaded: boolean,
  route: {
    match: {
      params: {
        courseId: string,
        moduleId: string,
      },
    },
  },
  done: string => void,
  language: string,
};

type StateType = {
  visibleModuleComponent: number,
  nextButtonDisabled: boolean,
  completed: boolean,
};

export const ModuleLoader = (props: PropsType): Node => {
  if (!props.loaded) {
    return <div>Loading Module</div>;
  }
  return (
    <Module {...props} />
  );
};



export class Module extends Component<PropsType, StateType> {
  courseId: string;
  resources: ResourcesType;
  moduleData: ModuleFieldsType;
  moduleComponentLength: number;
  completeModule: () => void;
  t: TranslateType
  constructor(props: PropsType) {
    super(props);
    const {route, resources} = props;
    const moduleId = route.match.params.moduleId;
    // $FlowFixMe
    const completeModuleHoF = (id: string): void => (): void => (
      this.props.done(id)
    );
    this.courseId = route.match.params.courseId;
    this.resources = resources;
    this.moduleData = this.resources.modules[moduleId];
    this.moduleComponentLength =
      resources.modules[moduleId].field_add_components.length;
    // $FlowFixMe
    this.completeModule = completeModuleHoF(moduleId);
    // state is only stuff local to Module that can change
    this.state = {
      visibleModuleComponent: 1,
      nextButtonDisabled: false,
      completed: false,
    };
    this.setStartedTimestamp();
    this.t = translate(this.props.language);
  }

  incrementVisible = () => {
    /* @flow weak */
    if (this.state.visibleModuleComponent < this.moduleComponentLength) {

      // @FlowFixMe
      this.setState((prevState: StateType): any => ({
        visibleModuleComponent: ++prevState.visibleModuleComponent,
      }));

        let lessons = document.querySelectorAll('.lesson-component');

        for (let i = 0; i < lessons.length; i++) {


          let video = lessons[i].querySelector(".youtubeVideo");

          if(video) {
            video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
          }

        }

    }
  }
  setStartedTimestamp = () => {

    let lessonTimestampStart = {
      userId: getFromLocalStorage(LOGIN.SUCCESS),
      moduleID: this.props.route.match.params.moduleId,
      started: Math.round((new Date()).getTime() / 1000),
    }

    lessonTimestampRequest(lessonTimestampStart).then((res: boolean): void => {});

  };

  setCompletedTimestamp = () => {
    const moduleID = this.props.route.match.params.moduleId;
    const userId = getFromLocalStorage(LOGIN.SUCCESS);
    const ts = Math.round((new Date()).getTime() / 1000);

    let lessonTimestampCompleted = {
      moduleID: moduleID,
      userId: userId,
      completed: ts
    }

    lessonTimestampRequest(lessonTimestampCompleted).then((res: boolean): void => {});

  };

  decrementVisible = () => {
    if (this.state.visibleModuleComponent > 1) {
      this.setState((prevState: StateType): any => ({
        visibleModuleComponent: --prevState.visibleModuleComponent,
      }));
    }
    let lessons = document.querySelectorAll('.lesson-component');

    for (let i = 0; i < lessons.length; i++) {


      let video = lessons[i].querySelector(".youtubeVideo");

      if(video) {
        video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
      }

    }
  }
  handleDisableButton = (willDisable: boolean) => {
    if (willDisable !== this.state.nextButtonDisabled) {
      this.setState({
        nextButtonDisabled: willDisable,
      });
    }
  }
  skipToComponent = (componentId: number) => {
    if (componentId <= this.moduleComponentLength) {
      this.setState({
        visibleModuleComponent: componentId,
      });
    }
  }
  completeModuleButton = () => {
    this.completeModule();
    this.setState({
      completed: true,
    });
    this.setCompletedTimestamp();
  };

  render(): * {
    if (!this.moduleData) {
      return <div>Module ID is not found</div>;
    }
    return (
      <Page>
        <ModuleInformation
          courseName={this.resources.courses[this.courseId].title[0].value }
          moduleName={ this.moduleData.title[0].value }
          currentModuleComponent={ this.state.visibleModuleComponent }
          moduleComponentLength={ this.moduleComponentLength } />
        <div className={styles.page}>
          <div className={styles.content}>
            <ModuleComponents
              modulesComponents={this.moduleData.field_add_components}
              allModuleComponents={this.resources.components}
              visibleModuleComponentId={this.state.visibleModuleComponent}
              t={this.t} />
            <ModuleProgress
              state={this.state}
              moduleComponentLength={this.moduleComponentLength}
              update={{
                decrement: this.decrementVisible,
                increment: this.incrementVisible,
                complete: this.completeModuleButton,
              }}
              courseId={this.courseId}
              t={this.t} />
          </div>
          <div className={styles.sidebar}>
            <Sidebar
              components={this.moduleData.field_add_components}
              allModuleComponents={this.resources.components}
              visibleModuleComponentId={this.state.visibleModuleComponent}
              skipToComponent={this.skipToComponent} />
          </div>
        </div>
        {
          // If you hit the complete module button
          this.state.completed && <Redirect
            to={`/course/${this.courseId}`} />
        }
      </Page>
    );
  }
}

type ModuleComponentsType = {
  components: Array<{
    target_id: string,
  }>,
  allModuleComponents: ModuleComponentType,
  visibleModuleComponentId: number,
  skipToComponent: (number) => void,
  children?: void,
};

const Sidebar = ({
                   components,
                   allModuleComponents,
                   visibleModuleComponentId,
                   skipToComponent,
                 }: ModuleComponentsType): Node => (
    <ol className={styles.index}>
      {
        components.map((
            component: {target_id: string},
            i: number
            ): Node => (
                // $FlowFixMe
                <li
                    key={i}
                    onClick={(): void => skipToComponent(i + 1)}
                    className={`${visibleModuleComponentId === i + 1 ? styles.currentModule : null} fontBrown`}
                    style={{
                      textDecoration: visibleModuleComponentId > i + 1 ? `line-through` : `none`,
                      color: visibleModuleComponentId < i + 1 ? `#73A0E3` : `#777`,
                    }}>
                  {
                    allModuleComponents[
                        component.target_id
                        ].type[0].target_id === 'lesson'
                        // $FlowFixMe
                        ? allModuleComponents[component.target_id].field_headline[0].value
                        : 'Question'
                  }
                </li>
            )
        )
      }
    </ol>
);

type LessonTimestampRequestType = {
  moduleID: string,
  userID: string,
  started: string,
  completed: string,
};

const lessonTimestampRequest = ({
      userId,
      moduleID,
      started,
      completed,
    }: LessonTimestampRequestType): * => {
  const body = {
    userId: userId,
    moduleID: moduleID,
    started: started,
    completed: completed,
  };
  const url = `https://${staging === true ? 'staging' : 'www' }.cambridgeaudio.com/gbr/en/api/learning/module/timestamps`;
  return req(url, body).then((res: any): boolean => {
    return true;
  }).catch((err: any): boolean => false);
};

type BodyType = {
  userId: string,
  moduleID: string,
  started: string,
  completed: string,
};



const req = (url: string, body: BodyType): * => fetch(url, {
  body: JSON.stringify(body),
  cache: 'no-cache',
  method: 'POST',
  mode: 'cors',
  headers: {
    'content-type': 'application/json',
  },
});



// WEBPACK FOOTER //
// ./src/components/Module/Module.js